export default __webpack_public_path__ + "static/media/TBTB.ba791cd1.jpg";